/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FinanceType = {
    Budget: 'BUDGET',
    DailyRate: 'DAILY_RATE'
} as const;
export type FinanceType = typeof FinanceType[keyof typeof FinanceType];


export function instanceOfFinanceType(value: any): boolean {
    for (const key in FinanceType) {
        if (Object.prototype.hasOwnProperty.call(FinanceType, key)) {
            // @ts-ignore
            if (FinanceType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FinanceTypeFromJSON(json: any): FinanceType {
    return FinanceTypeFromJSONTyped(json, false);
}

export function FinanceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinanceType {
    return json as FinanceType;
}

export function FinanceTypeToJSON(value?: FinanceType | null): any {
    return value as any;
}

